import Modal from './modules/modal';
import Inputmask from './modules/inputmask';
import AuthUi from './modules/auth-ui';

// Use an updated, non-jquery version of ajaxcom for login page
// @TODO convert all instances of ajaxcom to one version
const Ajaxcom = require('@everlutionsk/ajaxcom');

global.Modal = new Modal();

Ajaxcom.initialize({
    linksSelector: "#navigation a:not([data-ignore-ajaxcom]), .cover-container a:not([data-ignore-ajaxcom])",
    formsSelector: "form:not([data-ignore-ajaxcom])",
    beforeSend: () => {
    },
    complete: () => {
        Inputmask.constructor();
        AuthUi.resetLoading();
        AuthUi.init();
    },
    error: (e) => {
        console.error(e);
    }
});

AuthUi.init();

// Returning with the back button can restore a page whose button is still spinning.
window.addEventListener('pageshow', () => AuthUi.resetLoading());
